import { useEffect } from "react";
import Script from "next/script";
import { sendEvent } from "@JohnLewisPartnership/experiments-utils";
import { Breadcrumb } from "../../types/types";
import { dispatchAnalyticsEvent } from "../../utils";
import { usePrivacyFunctionalAccepted } from "../../hooks/usePrivacyFunctionalAccepted/usePrivacyFunctionalAccepted";

declare const window: any; // eslint-disable-line @typescript-eslint/no-explicit-any
const FIT_FINDER_CLICK_EVENT = "fit_finder_click_event";
const SIZE_INFO_CLICK_EVENT = "size_and_fit_click_event";

type FitFinderSize = {
  value: string;
  isAvailable: boolean;
};

interface FitDetail {
  breadcrumb: Breadcrumb[];
  price: string;
  productName: string;
  productId: string;
  brand: string;
  category: string | undefined;
  sku: string;
}

type FitFinderProps = {
  mainThumbnail: string;
  currentColour: string;
  sizes: Array<FitFinderSize>;
  brand: string;
  crumbs: Array<Breadcrumb>;
  price: string;
  skuTitle: string;
  productId: string;
  currentSkuId: string;
  fitFinderUrl: string;
};

export const FitFinderUI = ({
  mainThumbnail,
  currentColour,
  sizes,
  brand,
  price,
  crumbs,
  skuTitle,
  productId,
  currentSkuId,
  fitFinderUrl,
}: FitFinderProps) => {
  const hasAcceptedPrivacyTerms = usePrivacyFunctionalAccepted();

  useEffect(() => {
    window.fitAnalyticsData = {
      shopLanguage: "en",
      shopCountry: "GB",
      mainThumbnail: mainThumbnail,
      currentProductId: productId,
      currentColour: currentColour,
      allProductIds: [productId],
      experimentFunnel: "true",
      sizes: sizes,
    };

    document.body.addEventListener("open-fit-analytics", function () {
      const analyticsDetail = {
        breadcrumb: crumbs,
        price: price,
        productName: skuTitle,
        productId: productId,
        brand: brand,
        category: crumbs[crumbs.length - 1]?.value,
        sku: currentSkuId,
      };
      sendEvent(FIT_FINDER_CLICK_EVENT);
      sendEvent(SIZE_INFO_CLICK_EVENT);
      dispatchFitAnalyticsEvent(analyticsDetail);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSkuId]);

  return (
    <>
      {hasAcceptedPrivacyTerms && (
        <Script
          data-testid={"fit-finder-script"}
          src={fitFinderUrl}
          type="text/javascript"
        />
      )}
      <div
        id="fitanalytics-size-advisor"
        aria-label="fit analytics"
        data-component="FitFinder"
      ></div>
    </>
  );
};

const dispatchFitAnalyticsEvent = (detail: FitDetail) => {
  dispatchAnalyticsEvent(
    "global.fitFinder",
    {
      location: "pdp",
      pageName: "jl:fit finder:your measurements",
      breadCrumb: [
        {
          value: detail.breadcrumb[0],
          clickable: 1,
        },
        {
          value: detail.breadcrumb[1],
          clickable: 1,
        },
      ],
      product: {
        price: detail.price,
        productName: detail.productName,
        productId: detail.productId,
        brand: detail.brand,
        category: detail.category,
        displayedSku: detail.sku,
      },
    },
    {},
  );
};
